<template>
    <button
        type="button"
        :title="buttonTitle"
        @click="$emit('click', $event)"
    >
        <kgr-icon
            icon-class="signature"
            :disabled="disabled"
            style="vertical-align: middle"
        />
    </button>
</template>

<script>
import Icon from '../../common/icon/Icon.vue';
import SignableLetter from '../../../js/dto/letter/SignableLetter.js';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        letter:  {
            type: SignableLetter,
            required: true,
        },
        view: {
            type: String,
            validate(val) {
                return val === 'employee' || val === 'custody';
            },
            required: true,
        },
    },
    computed: {
        disabled() {
            return !this.letter.isAllowedToEdit || this.letter.getSignableSignatures().length === 0;
        },
        buttonTitle() {
            if(!this.letter.isAllowedToEdit) {
                switch(this.view) {
                    case 'employee':
                        return this.$t('Das Dokument kann nur vom Admin oder Sub-Admin unterschrieben werden.');
                    case 'custody':
                        return this.$t('Das Dokument kann nur von sorgenberechtigten Bezugspersonen unterschrieben werden. Für mehr Informationen wenden Sie sich bitte direkt an die Einrichtung.');
                }
            }
            if(this.letter.getSignableSignatures().length === 0) {
                return this.$t('Für Sie gibt es keine auszufüllenden Unterschriften in diesem Dokument (mehr).');
            }
            return this.$t('Klicken Sie, um das digitale Signieren dieses Dokuments zu starten');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
